import { useSeo } from "../lib/seo";
import { Link } from "react-router-dom";

export default function NotFound() {
  useSeo({ title: "Page not found | DITHER", description: "This page doesn't exist.", noindex: true });
  return (
    <div className="mx-auto max-w-xl px-4 py-20 text-center" data-testid="not-found-page">
      <p className="comic-title text-7xl text-pop-pink">404</p>
      <p className="mt-4 font-display text-2xl font-bold uppercase">DITHER couldn't decide where this goes.</p>
      <Link to="/" className="btn-pop mt-8 inline-flex rounded-2xl bg-pop-yellow px-6 py-3 font-display font-bold uppercase" data-testid="not-found-home-link">Take me home</Link>
    </div>
  );
}
